import { render, staticRenderFns } from "./GTable.vue?vue&type=template&id=6e45c3fe&"
import script from "./GTable.vue?vue&type=script&lang=js&"
export * from "./GTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports